var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstruction1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "thing",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 611.626,
    height: 461.734,
    viewBox: "0 0 611.626 461.734",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      :root {\n      --primary-color: #9138b0;\n      --secondary-color: #D9B0EA;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_350",
    width: 611.626,
    height: 461.734,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    d: "M1.055,412.544c63.125,29.374,140.717,46.69,224.6,46.69,211.79,0,383.47-110.37,383.47-246.52,0-89.045-73.445-167.064-183.52-210.388m-27.94,138.928c33.43,21.49,52.6,47.54,52.6,71.46s-19.17,49.98-52.6,71.47c-44.12,28.36-106.81,44.63-172.01,44.63s-127.89-16.27-172-44.63",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    d: "M551.809,286.259l-66.37,42.977-.613-55.251,66.722-43.205Z",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    d: "M551.809,286.259l-66.37,42.977-.613-55.251,66.722-43.205Z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    d: "M570.6,234.546,430.3,325.4a15.1,15.1,0,0,1-23.31-12.676v-116.8a15.1,15.1,0,0,1,6.893-12.677L554.188,92.4A15.1,15.1,0,0,1,577.5,105.073v116.8a15.1,15.1,0,0,1-6.894,12.677",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    d: "M570.6,234.546,430.3,325.4a15.1,15.1,0,0,1-23.31-12.676v-116.8a15.1,15.1,0,0,1,6.893-12.677L554.188,92.4A15.1,15.1,0,0,1,577.5,105.073v116.8A15.1,15.1,0,0,1,570.6,234.546Z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    d: "M582.823,242.184l-140.3,90.851a15.1,15.1,0,0,1-23.31-12.676v-116.8a15.1,15.1,0,0,1,6.893-12.677l140.3-90.851a15.1,15.1,0,0,1,23.311,12.676v116.8a15.1,15.1,0,0,1-6.894,12.677",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    d: "M582.823,242.184l-140.3,90.851a15.1,15.1,0,0,1-23.31-12.676v-116.8a15.1,15.1,0,0,1,6.893-12.677l140.3-90.851a15.1,15.1,0,0,1,23.311,12.676v116.8A15.1,15.1,0,0,1,582.823,242.184Z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstruction1);
export default __webpack_public_path__ + "static/media/instruction1.b3a7876a67363d6e66372eb5acccff44.svg";
export { ForwardRef as ReactComponent };